import { SVGIconComponent } from './types';

export const Switch: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M14.6498549,3.29319983 C15.0154957,2.90226672 15.6096562,2.90226672 15.9752969,3.29319983 L19.7257582,7.29253024 C20.0913989,7.68346334 20.0913989,8.31626666 19.7257582,8.70719977 L15.9752969,12.7074902 C15.6096562,13.0974873 15.0154957,13.0974873 14.6498549,12.7074902 C14.2833367,12.3165571 14.2833367,11.6837537 14.6498549,11.2928206 L16.7997549,8.9997096 L5.93696279,8.9997096 C5.41926053,8.9997096 5,8.55252091 5,8.000333 C5,7.44814508 5.41926053,7.0000204 5.93696279,7.0000204 L16.7997549,7.0000204 L14.6498549,4.70690937 C14.2833367,4.31691225 14.2833367,3.68317294 14.6498549,3.29317583 L14.6498549,3.29319983 Z M10.3501451,13.2924858 C10.7166633,13.6834189 10.7166633,14.3162223 10.3501451,14.7071554 L8.20024511,17.0002664 L19.0630372,17.0002664 C19.5807395,17.0002664 20,17.4474551 20,17.999643 C20,18.5518309 19.5807395,18.9999556 19.0630372,18.9999556 L8.20024511,18.9999556 L10.3501451,21.2930666 C10.7166633,21.6830637 10.7166633,22.3168031 10.3501451,22.7068002 C9.98450433,23.0977333 9.39034378,23.0977333 9.02470306,22.7068002 L5.27424179,18.7074698 C5.09845298,18.5199712 5,18.264961 5,17.999667 C5,17.734373 5.09844173,17.4802868 5.27424179,17.2928002 L9.02470306,13.2925098 C9.39034378,12.9025127 9.98450433,12.9025127 10.3501451,13.2925098 L10.3501451,13.2924858 Z"
        id="Shape"
        fill="#848484"
        fillRule="nonzero"
        transform="translate(12.5, 13) rotate(45) translate(-12.5, -13)"
      ></path>
    </g>
  </svg>
);
